import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchQueryMessages = async (queryId) => {
  const token = localStorage.getItem("token");

  const response = await axios.get(
    `${__API_URL__}/api/ecrf/get_query_messages/?query_id=${queryId}`,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return response.data;
};

const useGetQueryMessages = ({ queryId, enabled = true }) => {
  return useQuery({
    queryKey: ["query_messages", queryId],
    queryFn: () => fetchQueryMessages(queryId),
    enabled: enabled && Boolean(queryId),
  });
};

export default useGetQueryMessages;
